import { styled, Typography } from "@mui/material";

export const NoteText = styled(Typography)(({ theme }) => ({
  fontSize: "0.95rem",
  color: theme.palette.grey[800],
}));

export const PasswordPolicy = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  color: theme.palette.grey[700],
}));
